import { Form } from "@/helpers/Form";
import Pager from "@/helpers/Pager";
import { FilterModel } from "../services/OwnersService";

export default {
    namespaced: true,
    state: {
        filter: Form.createPersistedState<FilterModel>({
            showNonActive: false,
            propertyPublicId: null,
            name: ''
        }, undefined, 'renterOwnersFilter'),
        pager: new Pager(1, undefined, 'GivenName', 'ASC')
    }
};
